import "./CyberMediaGuide.module.css";
import Header from "@/reusable_sections/Header";
import CyberMediaGuidelines from "./sections/CyberMediaGuidelines";
import Footer from "@/reusable_sections/Footer";
export default function CyberMediaGuidePage() {
  return <div>
      <Header />
      <CyberMediaGuidelines />
      <Footer />
    </div>;
}